import SiteLayout from "@/components/feature/SiteLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import Hero from "@/pages/home/components/Hero";
import Marquee from "@/pages/home/components/Marquee";
import ServicesOverview from "@/pages/home/components/ServicesOverview";
import AudienceSection from "@/pages/home/components/AudienceSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  useDocumentMeta({
    title: "d.mar | Şişli Dental Röntgen ve 3D Tomografi Merkezi",
    description:
      "Osmanbey / Şişli'de dental görüntüleme merkezi. Panoramik röntgen, 3D dental tomografi (CBCT), sefalometrik ve TME çekimleri; düşük doz, aynı gün dijital rapor.",
    path: "/",
  });

  return (
    <SiteLayout>
      <Hero />
      <Marquee />
      <ServicesOverview />
      <AudienceSection />
      <CtaSection />
    </SiteLayout>
  );
}